// LIVE / STAGING
let baseUrl = location.protocol + '//' + location.host
let baseUrlApi = baseUrl + '/api'
// let gpApi = baseUrl

// BASE URL LIVE
// let baseUrl = 'http://tbm.monstercode.net'
// let baseUrlApi = baseUrl+'/api'

const apiRoute = {

  'baseUrl' : baseUrl,
  'register' : baseUrlApi+'/register',
  'forgot_password': baseUrlApi+'/password/reset',
  'forgot_password_confirm': baseUrlApi+'/password/reset/confirm',
  'forgot_password_setting' : baseUrlApi+'/password/reset/setting',
  'provinces' : baseUrlApi+'/get/data/provinces',
  'cities' : baseUrlApi+'/get/data/cities/',
  'districts' : baseUrlApi+'/get/data/districts/',
  'villages' : baseUrlApi+'/get/data/villages/',
  'customers' : baseUrlApi+'/get/data/customers',

  //NEW API PAGINATION SERVER-SIDE
  'customers_sales': baseUrlApi+'get/data/customers/sales',

  'roles_sales' : baseUrlApi+'/get/data/roles/sales',
  'roles_customers' : baseUrlApi+'/get/data/roles/customers',
  'sales_structure' : baseUrlApi+'/get/data/sales/',
  'sales_id' : baseUrlApi+'/get/salesid',
  'customers_sales' : baseUrlApi+'/get/data/customers/sales', // + {role_id}
  'view_data_sales' : baseUrlApi+'/view/data/sales/', //+ {id}
  'view_all_sales' : baseUrlApi+'/view/all/sales',
  'reports' : baseUrlApi+'/get/data/reports',
  'print_reports' : baseUrlApi+'/get/data/print_reports',

  'generate_sales_id' : baseUrlApi+'/get/generatesalesid',
  'create_sales' : baseUrlApi+'/create/sales',
  'update_sales_status' : baseUrlApi+'/update/sales/status/',
  'update_sales' : baseUrlApi+'/update/sales/', // + {id}
  'check_username_sales' : baseUrlApi+'/check/username/sales', // BODY form-data: user_name
  'check_email_sales' : baseUrlApi+'/check/email/sales', // BODY form-data: email

  'create_owner' : baseUrlApi+'/create/owner',
  'update_owner' : baseUrlApi+'/update/owner/', // + {owner_id}

  'create_customers' : baseUrlApi+'/create/customers',
  'update_customers' : baseUrlApi+'/update/customers/', // + {cust_id}
  'update_customers_status' : baseUrlApi+'/update/customers/status/', // + {cust_id}
  'view_data_customer' : baseUrlApi+'/get/data/customers/', // + {cust_id}
  'view_list_sales_by_id' : baseUrlApi+'/view/list/sales/', // + {id}
  'add_member' : baseUrlApi+'/update/sales/parentid/', // + {sales_id}, BODY form-data: parent_id

  // 'delete_customers' : baseUrlApi+'/delete/customers/',

  // 'refresh_token' : baseUrlApi+'/refresh/token',
  'change_password' : baseUrlApi+'/user/change/password',
  'profile' : baseUrlApi+'/user/profile',
  'profile_edit' : baseUrlApi+'/user/profile/edit',

  'reset_password' : baseUrlApi+'/reset/password/sales/', // + {id}
  'storage' : baseUrl+'/storage/app/', // + {image_path}

  /** New Login */
  // 'login' : baseUrlApi+'/login',
  'login' : baseUrl+'/oauth/token',
  'refresh_token' : baseUrlApi+'/oauth/token',

  /** new login local **/
  // 'login' : baseUrl+'/tbm-backend/public/oauth/token',


  //USER Get Role
  //'get_me': gpApi+"/v1/user/me"
  'get_role': baseUrlApi+"/get/role/" // + {email}

};

export function apiRouter(){
  return apiRoute;
}
